import { Component, OnInit } from '@angular/core';
import { PersonInMarinaService } from 'src/app/services/access-controler/person-in-marina.service';
import {
  PersonInMarinaDTO,
  PersonInMarinaFilter,
  PersonInMarinaType,
} from 'src/app/models/dtos/access-controller/person-in-marina.dto';

@Component({
  selector: 'app-person-in-marina-panel',
  templateUrl: './person-in-marina-panel.component.html',
  styleUrls: ['./person-in-marina-panel.component.scss'],
})
export class PersonInMarinaPanelComponent implements OnInit {
  list: PersonInMarinaDTO[] = [];
  loading = false;
  filter: { type?: PersonInMarinaType | ''; isResponsiblePresent?: boolean | '' } = { type: '', isResponsiblePresent: '' };

  typeOptions: { label: string; value: PersonInMarinaType | '' }[] = [
    { label: 'PESSOAS-NA-MARINA.ALL-TYPES', value: '' },
    { label: 'PESSOAS-NA-MARINA.CUSTOMER', value: 'CUSTOMER' },
    { label: 'PESSOAS-NA-MARINA.VISITOR', value: 'VISITOR' },
    { label: 'PESSOAS-NA-MARINA.SAILOR', value: 'SAILOR' },
    { label: 'PESSOAS-NA-MARINA.COLABORADOR', value: 'COLABORADOR' },
  ];

  responsiblePresentOptions: { label: string; value: boolean | '' }[] = [
    { label: 'PESSOAS-NA-MARINA.ALL', value: '' },
    { label: 'PESSOAS-NA-MARINA.RESPONSIBLE-PRESENT', value: true },
    { label: 'PESSOAS-NA-MARINA.RESPONSIBLE-ABSENT', value: false },
  ];

  constructor(private personInMarinaService: PersonInMarinaService) {}

  ngOnInit(): void {
    this.load();
  }

  private buildFilter(): PersonInMarinaFilter {
    const typeVal = this.filter.type;
    const respVal = this.filter.isResponsiblePresent;
    return {
      type: (typeVal && typeVal.length > 0) ? typeVal as PersonInMarinaType : undefined,
      isResponsiblePresent: (typeof respVal === 'boolean') ? respVal : undefined,
    };
  }

  load(): void {
    this.loading = true;
    this.personInMarinaService.listCurrentlyInMarina(this.buildFilter()).subscribe({
      next: (data) => {
        this.list = data ?? [];
        this.loading = false;
      },
      error: () => {
        this.list = [];
        this.loading = false;
      },
    });
  }

  onFilterChange(): void {
    this.load();
  }

  getTypeIcon(type: PersonInMarinaType): string {
    const icons: Record<PersonInMarinaType, string> = {
      CUSTOMER: 'pi-user',
      VISITOR: 'pi-users',
      SAILOR: 'pi-compass',
      COLABORADOR: 'pi-user-edit',
    };
    return icons[type] ?? 'pi-user';
  }

  getTypeLabel(type: PersonInMarinaType): string {
    const labels: Record<PersonInMarinaType, string> = {
      CUSTOMER: 'PESSOAS-NA-MARINA.CUSTOMER',
      VISITOR: 'PESSOAS-NA-MARINA.VISITOR',
      SAILOR: 'PESSOAS-NA-MARINA.SAILOR',
      COLABORADOR: 'PESSOAS-NA-MARINA.COLABORADOR',
    };
    return labels[type] ?? type;
  }

  getTypeCssClass(type: PersonInMarinaType): string {
    const classes: Record<PersonInMarinaType, string> = {
      CUSTOMER: 'type-customer',
      VISITOR: 'type-visitor',
      SAILOR: 'type-sailor',
      COLABORADOR: 'type-colaborador',
    };
    return classes[type] ?? '';
  }

  showResponsibleFilter(): boolean {
    const t = this.filter.type;
    return t === 'VISITOR' || !t || (t as string) === '';
  }

  showResponsibleColumn(): boolean {
    return this.showResponsibleFilter();
  }

  showCodRegistrationColumn(): boolean {
    const t = this.filter.type;
    return t === 'CUSTOMER' || !t || (t as string) === '';
  }

  getEmptyColspan(): number {
    let cols = 6; // type, photo, name, colectId, lastAccessPoint, lastAccessTime
    if (this.showCodRegistrationColumn()) cols++;
    if (this.showResponsibleColumn()) cols++;
    return cols;
  }
}
